import React from "react";

const SvgNotifications = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_6140_2583)">
      <path
        d="M17.7509 15.8536V16.6947H2.19531V15.8536L2.21501 15.8362L2.21504 15.8363L2.22021 15.8316C2.78109 15.3226 3.27142 14.741 3.67819 14.1021L3.69086 14.0822L3.70159 14.0612C4.15734 13.17 4.4305 12.1968 4.50504 11.1986L4.50642 11.18V11.1613L4.50642 8.41688L4.50642 8.41587C4.50374 7.08438 4.98368 5.79702 5.85736 4.79225C6.73104 3.78747 7.93925 3.13336 9.25821 2.95106L9.68976 2.89142V2.45577V1.72799C9.68976 1.6639 9.71522 1.60243 9.76054 1.55711C9.80586 1.51179 9.86733 1.48633 9.93142 1.48633C9.99552 1.48633 10.057 1.51179 10.1023 1.55711C10.1476 1.60243 10.1731 1.6639 10.1731 1.72799V2.44466V2.88484L10.6097 2.94063C11.9406 3.11067 13.1636 3.76085 14.0489 4.76901C14.9342 5.77717 15.4209 7.07393 15.4175 8.41563V8.41688V11.1613V11.18L15.4189 11.1986C15.4935 12.1968 15.7666 13.17 16.2224 14.0612L16.2339 14.0837L16.2476 14.1049C16.6615 14.7455 17.1599 15.3273 17.7294 15.8346L17.7312 15.8362L17.7509 15.8536Z"
        stroke="#0C0324"
      />
      <path
        d="M8.51172 17.7773C8.56044 18.1295 8.73494 18.4521 9.00299 18.6857C9.27104 18.9192 9.61454 19.0478 9.97005 19.0478C10.3256 19.0478 10.6691 18.9192 10.9371 18.6857C11.2052 18.4521 11.3797 18.1295 11.4284 17.7773H8.51172Z"
        fill="#0C0324"
      />
    </g>
    <defs>
      <clipPath id="clip0_6140_2583">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgNotifications;
